<template>
  <div
    class="toolbar-icon"
    :title="$t('Unmerge Cells')"
    :style="{ opacity: activeTable || conflicts ? '0.5' : '1' }"
    @click="unmerge"
  >
    <custom-icon :class-name="computedclassName" />
  </div>
</template>
<script>
import CustomIcon from "../../commons/CustomIcon.vue";

import { icons } from "../../../utils/icons";
import DesignerMixin from "../DesignerMixin";
export default {
  components: { CustomIcon },
  mixins: [DesignerMixin],
  data() {
    return {
      icons: icons,
      conflicts: false,
    };
  },
  computed: {
    computedclassName() {
      return icons.Unmerge;
    },

    activeRange() {
      return this.$store.getters["cells/activeRange"];
    },
    activeTable() {
      return this.$store.state.table.activeTable;
    },
  },
  watch: {
    async mainRange() {
      if (this.mainRange?.range) {
        this.conflicts = this.$store.getters["table/tableRangeConflict"]({
          table: null,
          range: this.mainRange?.range,
        });
      }
    },
  },
  methods: {
    async unmerge() {
      if (this.activeTable || this.conflicts) return;
      const editMode = this.$store.state.pdesign.editMode.value;
      this.$store.dispatch("pdesign/setEditMode", editMode);
      this.$store.dispatch("cells/unmerge", { merge: true }, { root: true });
    },
    callFunc() {
      this.unmerge();
    },
  },
};
</script>
